import React, { useState, useEffect } from "react";
import { useSnackBar } from "../../../../hooks/useSnackBar";
import { useTranslation } from "react-i18next";
import "../../InvoiceModal.css";

// components imports
import CircularLoader from "../../../CircularLoader/CircularLoader";
import ImagesModal from "../../../../Pages/Shipper/Customer/MainPages/Orders/Components/OrderHistoryModal/ImagesModal/ImagesModal";
import Tooltip from "../../../Tooltip/Tooltip";
import SwitchButton from "../../../../Components/SwitchButton/SwitchButton";
import Attachments from "../Attachments/Attachments";

// library imports
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { MdAdd } from "react-icons/md";
import Select from "@mui/material/Select";
import { TextField } from "@mui/material";
import {
  MdOutlineKeyboardArrowDown,
  MdOutlineKeyboardArrowUp,
} from "react-icons/md";
import IconButton from "@mui/material/IconButton";

// apis imports
import {
  updateShipment,
  updateAdminShipment,
} from "../../../../services/admin.services";

// helpers imports
import { checkFileType, convertTime } from "../../../../helpers/helpers";

// asset imports
import noImage from "../../../../assets/images/noImage.png";
import pdfIcon from "../../../../assets/icons/pdfIcon.png";
import excelIcon from "../../../../assets/icons/excelIcon.png";

const AdminActions = ({
  data,
  setData,
  setShipments,
  getAllShipments,
  type,
}) => {
  const { t } = useTranslation("finances");
  const [loading, setLoading] = useState();
  const [attachmentsModal, setAttachmentsModal] = useState();
  const [fullview, setfullview] = useState();
  const setSnack = useSnackBar();
  const [isModified, setIsModified] = useState(false);
  const [isIdModified, setIsIdModified] = useState(false);
  const [InvoiceDescription, setInvoiceDescription] = useState("");
  const [adminInvoiceId, setAdminInvoiceId] = useState("");
  const [visible, setVisible] = useState(
    type === "admin" || type === "user" ? true : false,
  );

  const handleDescriptionChange = (event) => {
    const newDescription = event.target.value;
    const isDescriptionModified =
      (data?.invoice_description !== null &&
        newDescription !== data?.invoice_description) ||
      (data?.invoice_description === null && newDescription !== "");
    // console.log(isDescriptionModified);
    setInvoiceDescription(newDescription);
    setIsModified(isDescriptionModified);
  };
  const handleAdminIdChange = (value) => {
    const newId = value;
    const isModified =
      (data?.admin_invoice_id !== null && newId !== data?.admin_invoice_id) ||
      (data?.admin_invoice_id === null && newId !== "");
    setAdminInvoiceId(newId);
    setIsIdModified(isModified);
  };

  const handleAdminId = async () => {
    setLoading("Admin_id");

    try {
      const formData = new FormData();
      formData.append("admin_invoice_id", adminInvoiceId);
      let response = "";
      response = await updateAdminShipment(formData, data?.id);
      setLoading(false);
      if (!response?.error) {
        setSnack((snack) => {
          return {
            ...snack,
            open: true,
            text: t("invoice.actions.idUpdated"),
            severity: "success",
          };
        });
        setIsIdModified(false);
        setInvoiceDescription("");

        setData({
          ...data,
          admin_invoice_id: response?.data?.result?.admin_invoice_id,
        });
        setShipments((prevShipments) => {
          return {
            ...prevShipments,
            data: prevShipments?.data?.map((shipment) => {
              if (shipment.id === data.id) {
                return {
                  ...shipment,
                  admin_invoice_id: response?.data?.result?.admin_invoice_id,
                };
              } else {
                return shipment;
              }
            }),
          };
        });
      } else {
        setSnack((snack) => {
          return {
            ...snack,
            open: true,
            text: t("common:messages.somethingWentWrong"),
            severity: "error",
          };
        });
      }
    } catch (error) {
      setLoading(false);
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
    }
  };
  const handleAdminNotes = async () => {
    setLoading("Admin_notes");

    try {
      const formData = new FormData();
      formData.append("invoice_description", InvoiceDescription);
      // formData.append("type", type ?? "admin");

      let response = "";
      if (type === "user") {
        response = await updateShipment(formData, data?.id);
      } else {
        response = await updateAdminShipment(formData, data?.id);
      }
      // console.log(response?.data?.result?.invoice_description);
      setLoading(false);
      if (!response?.error) {
        setSnack((snack) => {
          return {
            ...snack,
            open: true,
            text: t("invoice.actions.notesUpdated"),
            severity: "success",
          };
        });
        setIsModified(false);
        setInvoiceDescription("");

        setData({
          ...data,
          shipment_notes: response?.data?.result?.shipment_notes,
        });
        setShipments((prevShipments) => {
          return {
            ...prevShipments,
            data: prevShipments?.data?.map((shipment) => {
              if (shipment.id === data.id) {
                return {
                  ...shipment,
                  shipment_notes: response?.data?.result?.shipment_notes,
                };
              } else {
                return shipment;
              }
            }),
          };
        });
      } else {
        setSnack((snack) => {
          return {
            ...snack,
            open: true,
            text: t("common:messages.somethingWentWrong"),
            severity: "error",
          };
        });
      }
    } catch (error) {
      setLoading(false);
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
    }
  };

  const handleAdminAttachmentChange = async (e) => {
    const files = e.target.files;
    if (files.length === 0) {
      return;
    }
    setLoading("attachment");
    try {
      const files = e.target.files;
      const formData = new FormData();
      files.forEach((file, index) => {
        formData.append(`attachment[${index}]`, file);
      });
      // formData.append("type", type ?? "admin");
      let response = "";
      if (type === "user") {
        response = await updateShipment(formData, data?.id);
      } else {
        response = await updateAdminShipment(formData, data?.id);
      }

      setLoading(false);
      if (!response?.error) {
        setSnack((snack) => {
          return {
            ...snack,
            open: true,
            text: t("invoice.actions.attachmentAdded"),
            severity: "success",
          };
        });
        setData({
          ...data,
          media: response?.data?.result?.media,
        });
        setShipments((prevShipments) => {
          return {
            ...prevShipments,
            data: prevShipments?.data?.map((shipment) => {
              if (shipment.id === data.id) {
                return {
                  ...shipment,
                  media: response?.data?.result?.media,
                };
              } else {
                return shipment;
              }
            }),
          };
        });
      } else {
        setSnack((snack) => {
          return {
            ...snack,
            open: true,
            text: t("common:messages.somethingWentWrong"),
            severity: "error",
          };
        });
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
    }
  };
  const handleBillingVerfication = async (e) => {
    setLoading("verification");
    const statusObj =
      type === "user"
        ? { user_invoice_status: e.target.value }
        : { admin_invoice_status: e.target.value };
    setData({
      ...data,
      ...statusObj,
    });
    try {
      const formData = new FormData();
      const statusKey =
        type === "user" ? "user_invoice_status" : "admin_invoice_status";
      formData.append(statusKey, e.target.value);
      // formData.append("type", type ?? "admin");
      let response = "";
      if (type === "user") {
        response = await updateShipment(formData, data?.id);
      } else {
        response = await updateAdminShipment(formData, data?.id);
      }
      setLoading(false);
      if (!response?.error) {
        setSnack((snack) => {
          return {
            ...snack,
            open: true,
            text: t("invoice.actions.statusUpdated"),
            severity: "success",
          };
        });
        setShipments((prevShipments) => {
          return {
            ...prevShipments,
            data: prevShipments?.data?.map((shipment) => {
              if (shipment.id === data.id) {
                const statusObj =
                  type === "user"
                    ? {
                        user_invoice_status:
                          response?.data?.result?.user_invoice_status,
                      }
                    : {
                        admin_invoice_status:
                          response?.data?.result?.admin_invoice_status,
                      };

                return {
                  ...shipment,
                  ...statusObj,
                };
              } else {
                return shipment;
              }
            }),
          };
        });
      } else {
        setSnack((snack) => {
          return {
            ...snack,
            open: true,
            text: t("common:messages.somethingWentWrong"),
            severity: "error",
          };
        });
      }
    } catch (error) {
      setLoading(false);
      const statusObj =
        type === "user"
          ? {
              admin_invoice_status: !e.target.checked
                ? "verified"
                : "unverified",
            }
          : {
              user_invoice_status: !e.target.checked
                ? "verified"
                : "unverified",
            };
      setData({
        ...data,
        ...statusObj,
      });
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
    }
  };
  useEffect(() => {
    if (type === "admin") {
      if (data?.invoice_description?.trim()) {
        const invoiceDescription = {
          id: Math.floor(Math.random() * 10000000),
          notes: data.invoice_description,
          category: "description",
        };

        const lastShipmentNote = data?.shipment_notes?.length
          ? data.shipment_notes[data.shipment_notes.length - 1]
          : null;

        if (lastShipmentNote?.category !== "description") {
          setData((prevData) => ({
            ...prevData,
            shipment_notes: [
              ...(prevData.shipment_notes || []),
              invoiceDescription,
            ],
          }));
        }
      }
      if (data?.admin_invoice_id) {
        setAdminInvoiceId(data?.admin_invoice_id);
      }
    }
  }, [data]);

  const updateShipmentToggle = async ({
    field,
    checked,
    successText = t("invoice.actions.statusUpdated"),
  }) => {
    setLoading(field);

    const value = checked ? 1 : 0;

    // optimistic UI update
    setData((prev) => ({
      ...prev,
      [field]: value,
    }));

    try {
      const formData = new FormData();
      formData.append(field, value);

      const response = await updateAdminShipment(formData, data?.id);

      setLoading(false);

      if (!response?.error) {
        setSnack((prev) => ({
          ...prev,
          open: true,
          text: successText,
          severity: "success",
        }));

        setShipments((prevShipments) => ({
          ...prevShipments,
          data: prevShipments?.data?.map((shipment) =>
            shipment.id === data?.id
              ? {
                  ...shipment,
                  [field]: response?.data?.result?.[field],
                }
              : shipment,
          ),
        }));

        return;
      }

      throw new Error("Update failed");
    } catch (error) {
      // rollback optimistic update
      setData((prev) => ({
        ...prev,
        [field]: checked ? 0 : 1,
      }));

      setLoading(false);

      setSnack((prev) => ({
        ...prev,
        open: true,
        text: t("common:messages.somethingWentWrong"),
        severity: "error",
      }));
    }
  };

  const isChecked = (value) => ![0, "0", "false", false].includes(value);

  return (
    <>
      <ImagesModal setOpen={setfullview} open={fullview} />
      <div className="invmodal__editableinv_actions">
        <div className="invmodal__shipment_detailshding">
          {t("invoice.actions.title")}{" "}
          {type === "admin"
            ? t("invoice.actions.byAdmin")
            : type === "user" || type === "admin-user"
              ? t("invoice.actions.byUser")
              : ""}
          <Tooltip
            title={
              visible
                ? t("invoice.actions.collapse")
                : t("invoice.actions.expand")
            }
          >
            <IconButton onClick={() => setVisible(!visible)}>
              {visible ? (
                <MdOutlineKeyboardArrowUp size={25} />
              ) : (
                <MdOutlineKeyboardArrowDown size={25} />
              )}
            </IconButton>
          </Tooltip>
        </div>
        {visible && (
          <>
            <div className="invmodal__einvactions_content">
              <div className="invmodal__einvactions_contentlft">
                <div
                  className={`invmodal__shippymnt_verifiedtoggle ${
                    type === "admin-user" ? "disable__click_fade" : ""
                  }`}
                >
                  <label>{t("invoice.actions.invoiceStatus")} </label>
                  <FormControl
                    sx={{ width: "100%", textTransform: "capitalize" }}
                    variant="outlined"
                    size="small"
                  >
                    <Select
                      labelId="demo-select-small-label"
                      id="demo-select-small"
                      value={
                        (type === "user" || type === "admin-user"
                          ? data?.user_invoice_status
                          : data?.admin_invoice_status) ?? "none"
                      }
                      onChange={handleBillingVerfication}
                    >
                      <MenuItem disabled value="none">
                        <em>{t("invoice.actions.invoiceStatus")}</em>
                      </MenuItem>
                      <MenuItem value="Unpaid">
                        {t("invoice.actions.statuses.unpaid")}
                      </MenuItem>
                      <MenuItem value="Extra Charge Paid">
                        {t("invoice.actions.statuses.extraChargePaid")}
                      </MenuItem>
                      <MenuItem value="Less Charge Paid">
                        {t("invoice.actions.statuses.lessChargePaid")}
                      </MenuItem>
                      <MenuItem value="Paid">
                        {t("invoice.actions.statuses.paid")}
                      </MenuItem>
                      <MenuItem value="Disputed">
                        {t("invoice.actions.statuses.disputed")}
                      </MenuItem>
                      <MenuItem value="Duty Disputed">
                        {t("invoice.actions.statuses.dutyDisputed")}
                      </MenuItem>
                      <MenuItem value="Dispute Won">
                        {t("invoice.actions.statuses.disputeWon")}
                      </MenuItem>
                      <MenuItem value="Dispute Lost">
                        {t("invoice.actions.statuses.disputeLost")}
                      </MenuItem>
                      <MenuItem value="Refunded">
                        {t("invoice.actions.statuses.refunded")}
                      </MenuItem>
                      <MenuItem value="Other">
                        {t("invoice.actions.statuses.other")}
                      </MenuItem>
                    </Select>
                  </FormControl>
                </div>
                <div
                  className="invmodal__shippymnt_atbtnloaderwrap"
                  style={{
                    visibility: ["verification"].includes(loading)
                      ? "visible"
                      : "hidden",
                  }}
                >
                  <CircularLoader size={16} />
                </div>
              </div>
              {type === "admin" && (
                <>
                  <div className="invmodal__einvactions_contentrt">
                    <div className="invmodal__einvactions_contentrtformgroup">
                      <label>{t("invoice.actions.adminInvoiceId")} </label>

                      <div className="invmodal__einvactions_contentrtformfieldwrap">
                        <TextField
                          placeholder={t("invoice.actions.enterAdminInvoiceId")}
                          onChange={(e) => handleAdminIdChange(e.target.value)}
                          size="small"
                          sx={{ flex: 1 }}
                          value={adminInvoiceId}
                        />
                        {isIdModified && (
                          <button
                            className="update__charge_rblftbtnsave"
                            onClick={handleAdminId}
                          >
                            {loading === "Admin_id" ? (
                              <CircularLoader size={16} color="grey" />
                            ) : (
                              t("common:actions.save")
                            )}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="flex gap-4 flex-wrap">
                    {/* Billing Verification */}
                    <div className="flex flex-col min-w-[180px]">
                      <label className="text-xs font-medium text-ui-text">
                        {t("invoice.actions.billingVerification")}
                      </label>

                      <div className="mt-1 flex items-center gap-2">
                        <SwitchButton
                          onChange={(e) =>
                            updateShipmentToggle({
                              field: "is_bill_verified",
                              checked: e.target.checked,
                            })
                          }
                          checked={isChecked(data?.is_bill_verified)}
                          disabled={loading === "is_bill_verified"}
                        />

                        <span className="text-[11px] text-ui-text-muted w-[75px]">
                          {data?.is_bill_verified == 0
                            ? t("invoice.actions.unverified")
                            : t("invoice.actions.verified")}
                        </span>
                      </div>
                    </div>

                    {/* Duties & Taxes */}
                    {data?.single_shipping_invoice?.file && (
                      <div className="flex flex-col min-w-[180px]">
                        <label className="text-xs font-medium text-ui-text">
                          {t("invoice.actions.dutiesTaxes")}
                        </label>

                        <div className="mt-1 flex items-center gap-2">
                          <SwitchButton
                            onChange={(e) =>
                              updateShipmentToggle({
                                field: "is_duty_paid",
                                checked: e.target.checked,
                              })
                            }
                            checked={isChecked(data?.is_duty_paid)}
                            disabled={loading === "is_duty_paid"}
                          />

                          <span className="text-[11px] text-ui-text-muted w-[75px]">
                            {data?.is_duty_paid == 0
                              ? t("invoice.actions.unpaid")
                              : t("invoice.actions.paid")}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                </>
              )}
              {type !== "admin" && (
                <div className="invmodal__einvactions_contentrt">
                  <div className="invmodal__shippymnt_atchmentbtnwrap">
                    {attachmentsModal === "admin" && (
                      <Attachments
                        onClose={() => setAttachmentsModal(false)}
                        attachments={data?.media}
                        getAllShipments={getAllShipments}
                        setSnack={setSnack}
                        setData={setData}
                        setShipments={setShipments}
                        data={data}
                        type="admin"
                        size="small"
                      />
                    )}
                    <label>{t("invoice.attachments")} </label>
                    {type === "admin" && (
                      <>
                        {
                          <div className="notes__attachments_modal_attachment_thumbnail_wrap">
                            <div className="notes__attachments_modal_attachment_thumbnail notes__attachments_modal_attachment_thumbnail2">
                              {data?.media
                                ?.filter(
                                  (attachment) => attachment?.meta === "admin",
                                )
                                .map((attachment, index) => (
                                  <img
                                    key={attachment?.id}
                                    src={
                                      attachment?.file &&
                                      (checkFileType(attachment.file) ===
                                      "Image"
                                        ? attachment.file
                                        : checkFileType(attachment.file) ===
                                            "PDF"
                                          ? pdfIcon
                                          : checkFileType(attachment.file) ===
                                              "Excel"
                                            ? excelIcon
                                            : noImage)
                                    }
                                    alt={t("invoice.attachmentAlt", {
                                      n: index + 1,
                                    })}
                                    onError={(e) => {
                                      e.target.src = noImage;
                                    }}
                                    onClick={() => {
                                      if (
                                        checkFileType(attachment.file) ===
                                        "Image"
                                      ) {
                                        setfullview(attachment?.file || "");
                                      } else {
                                        window.open(attachment?.file, "_blank");
                                      }
                                    }}
                                  />
                                ))}
                              <div className="invmodal__shippymnt_addattachmnetbtnwrap">
                                <label className="invmodal__shippymnt_addattachmnetbtn2">
                                  <input
                                    type="file"
                                    hidden
                                    multiple
                                    id="update_charge_attachment2"
                                    onChange={handleAdminAttachmentChange}
                                  />

                                  <MdAdd size={20} />

                                  {/* <span>CLICK TO UPLOAD FILES</span> */}
                                </label>
                              </div>
                            </div>
                          </div>
                        }
                      </>
                    )}

                    {["user", "admin-user"].includes(type) && (
                      <div className="notes__attachments_modal_attachment_thumbnail_wrap">
                        <div className="notes__attachments_modal_attachment_thumbnail notes__attachments_modal_attachment_thumbnail2">
                          {data?.media
                            ?.filter(
                              (attachment) => attachment?.meta === "user",
                            )
                            .map((attachment, index) => (
                              <img
                                key={attachment?.id}
                                src={
                                  attachment?.file &&
                                  (checkFileType(attachment.file) === "Image"
                                    ? attachment.file
                                    : checkFileType(attachment.file) === "PDF"
                                      ? pdfIcon
                                      : checkFileType(attachment.file) ===
                                          "Excel"
                                        ? excelIcon
                                        : noImage)
                                }
                                alt={t("invoice.attachmentAlt", {
                                  n: index + 1,
                                })}
                                onError={(e) => {
                                  e.target.src = noImage;
                                }}
                                onClick={() => {
                                  if (
                                    checkFileType(attachment.file) === "Image"
                                  ) {
                                    setfullview(attachment?.file || "");
                                  } else {
                                    window.open(attachment?.file, "_blank");
                                  }
                                }}
                              />
                            ))}
                          {type === "user" && (
                            <div className="invmodal__shippymnt_addattachmnetbtnwrap">
                              <label className="invmodal__shippymnt_addattachmnetbtn2">
                                <input
                                  type="file"
                                  hidden
                                  multiple
                                  id="update_charge_attachment2"
                                  onChange={handleAdminAttachmentChange}
                                />

                                <MdAdd size={20} />
                              </label>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                  <span
                    className="invmodal__shippymnt_atbtnloaderwrap"
                    style={{
                      visibility: ["attachment"].includes(loading)
                        ? "visible"
                        : "hidden",
                    }}
                  >
                    <CircularLoader size={16} />
                  </span>
                </div>
              )}
            </div>
            {type === "admin" && (
              <div className="invmodal__einvactions_content">
                <div className="invmodal__einvactions_contentrt">
                  <div className="invmodal__shippymnt_atchmentbtnwrap">
                    {attachmentsModal === "admin" && (
                      <Attachments
                        onClose={() => setAttachmentsModal(false)}
                        attachments={data?.media}
                        getAllShipments={getAllShipments}
                        setSnack={setSnack}
                        setData={setData}
                        setShipments={setShipments}
                        data={data}
                        type="admin"
                        size="small"
                      />
                    )}
                    <label>{t("invoice.attachments")} </label>
                    {type === "admin" && (
                      <>
                        {
                          <div className="notes__attachments_modal_attachment_thumbnail_wrap">
                            <div className="notes__attachments_modal_attachment_thumbnail notes__attachments_modal_attachment_thumbnail2">
                              {data?.media
                                ?.filter(
                                  (attachment) => attachment?.meta === "admin",
                                )
                                .map((attachment, index) => (
                                  <img
                                    key={attachment?.id}
                                    src={
                                      attachment?.file &&
                                      (checkFileType(attachment.file) ===
                                      "Image"
                                        ? attachment.file
                                        : checkFileType(attachment.file) ===
                                            "PDF"
                                          ? pdfIcon
                                          : checkFileType(attachment.file) ===
                                              "Excel"
                                            ? excelIcon
                                            : noImage)
                                    }
                                    alt={t("invoice.attachmentAlt", {
                                      n: index + 1,
                                    })}
                                    onError={(e) => {
                                      e.target.src = noImage;
                                    }}
                                    onClick={() => {
                                      if (
                                        checkFileType(attachment.file) ===
                                        "Image"
                                      ) {
                                        setfullview(attachment?.file || "");
                                      } else {
                                        window.open(attachment?.file, "_blank");
                                      }
                                    }}
                                  />
                                ))}
                              <div className="invmodal__shippymnt_addattachmnetbtnwrap">
                                <label className="invmodal__shippymnt_addattachmnetbtn2">
                                  <input
                                    type="file"
                                    hidden
                                    multiple
                                    id="update_charge_attachment2"
                                    onChange={handleAdminAttachmentChange}
                                  />

                                  <MdAdd size={20} />

                                  {/* <span>CLICK TO UPLOAD FILES</span> */}
                                </label>
                              </div>
                            </div>
                          </div>
                        }
                      </>
                    )}

                    {["user", "admin-user"].includes(type) && (
                      <div className="notes__attachments_modal_attachment_thumbnail_wrap">
                        <div className="notes__attachments_modal_attachment_thumbnail notes__attachments_modal_attachment_thumbnail2">
                          {data?.media
                            ?.filter(
                              (attachment) => attachment?.meta === "user",
                            )
                            .map((attachment, index) => (
                              <img
                                key={attachment?.id}
                                src={
                                  attachment?.file &&
                                  (checkFileType(attachment.file) === "Image"
                                    ? attachment.file
                                    : checkFileType(attachment.file) === "PDF"
                                      ? pdfIcon
                                      : checkFileType(attachment.file) ===
                                          "Excel"
                                        ? excelIcon
                                        : noImage)
                                }
                                alt={t("invoice.attachmentAlt", {
                                  n: index + 1,
                                })}
                                onError={(e) => {
                                  e.target.src = noImage;
                                }}
                                onClick={() => {
                                  if (
                                    checkFileType(attachment.file) === "Image"
                                  ) {
                                    setfullview(attachment?.file || "");
                                  } else {
                                    window.open(attachment?.file, "_blank");
                                  }
                                }}
                              />
                            ))}
                          {type === "user" && (
                            <div className="invmodal__shippymnt_addattachmnetbtnwrap">
                              <label className="invmodal__shippymnt_addattachmnetbtn2">
                                <input
                                  type="file"
                                  hidden
                                  multiple
                                  id="update_charge_attachment2"
                                  onChange={handleAdminAttachmentChange}
                                />

                                <MdAdd size={20} />

                                {/* <span>CLICK TO UPLOAD FILES</span> */}
                              </label>
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    {/* <Tooltip title="Uploaded Attachments">
                <span
                  className="invmodal__shippymnt_attachmenicon"
                  // onClick={() => downloadFiles(data?.media)}
                  onClick={() => setAttachmentsModal("admin")}
                  style={{
                    visibility: data?.media?.length ? "visible" : "hidden",
                  }}
                >
                  {data?.media?.length ? (
                    <span className="invmodal__shippymnt_attachmenbadge">
                      {data?.media?.length ?? ""}
                    </span>
                  ) : (
                    ""
                  )}
                  <MdAttachment size={22} />
                </span>
              </Tooltip> */}
                  </div>
                  <span
                    className="invmodal__shippymnt_atbtnloaderwrap"
                    style={{
                      visibility: ["attachment"].includes(loading)
                        ? "visible"
                        : "hidden",
                    }}
                  >
                    <CircularLoader size={16} />
                  </span>
                </div>
              </div>
            )}
            {data?.shipment_notes?.length > 0 && (
              <div
                className="invmodal__note_user_box invoice__modal_user_box"
                style={{ height: "auto" }}
              >
                <div
                  className="invmodal__note_boxdesc"
                  style={{ minHeight: "fit-content" }}
                >
                  <table className="invmodal__spnote_table">
                    <tr className="invmodal__spnote_tableheading">
                      <th className="invmodal__spnote_tablecell">
                        {t("invoice.actions.note")}
                      </th>
                      <th className="invmodal__spnote_tablecell">
                        {t("invoice.actions.addedBy")}
                      </th>
                      <th className="invmodal__spnote_tablecell">
                        {t("invoice.actions.createdAt")}
                      </th>
                    </tr>
                    {["user", "admin-user"].includes(type) &&
                      data?.shipment_notes
                        ?.filter((item) => item.type === "user")
                        ?.map((note, index) => (
                          <tr key={index}>
                            <td className="invmodal__spnote_tablecell">
                              <div className="bolt__tablemax_fixed_height">
                                {note?.notes}
                              </div>
                            </td>
                            <td className="invmodal__spnote_tablecell">
                              <div className="bolt__tablemax_fixed_height">
                                {note?.type}
                              </div>
                            </td>
                            <td className="invmodal__spnote_tablecell">
                              <div className="bolt__tablemax_fixed_height">
                                {convertTime(note?.created_at)}
                              </div>
                            </td>
                          </tr>
                        ))}
                    {["admin"].includes(type) &&
                      data?.shipment_notes
                        ?.filter(
                          (item) =>
                            item.type === "admin" ||
                            item.category === "description",
                        )
                        ?.map((note, index) => (
                          <tr key={index}>
                            <td className="invmodal__spnote_tablecell">
                              <div className="bolt__tablemax_fixed_height">
                                {note?.notes}
                              </div>
                            </td>
                            <td className="invmodal__spnote_tablecell">
                              <div className="bolt__tablemax_fixed_height">
                                {note?.type}
                              </div>
                            </td>
                            <td className="invmodal__spnote_tablecell">
                              <div className="bolt__tablemax_fixed_height">
                                {convertTime(note?.created_at)}
                              </div>
                            </td>
                          </tr>
                        ))}
                  </table>
                </div>{" "}
              </div>
            )}

            {type !== "admin-user" && (
              <div className="update__charge_reasonbox">
                <div className="update__charge_reasonboxlft">
                  <label>{t("invoice.actions.addNote")} </label>
                  <textarea
                    className="invmodal__charge_desc"
                    placeholder={t("invoice.actions.writeNote")}
                    name="description"
                    onChange={handleDescriptionChange}
                    value={InvoiceDescription ?? ""}
                  ></textarea>
                </div>
              </div>
            )}
            <div className="update__charge_rblftbtns">
              {isModified && (
                <button
                  className="update__charge_rblftbtnsave"
                  onClick={handleAdminNotes}
                >
                  {loading === "Admin_notes" ? (
                    <CircularLoader size={16} color="grey" />
                  ) : (
                    t("common:actions.save")
                  )}
                </button>
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AdminActions;
